import Axios from "../config/axios-v1-config";

const COBRO = "/billing/cobro";
const PAY = "/integrations/payments";

// ── Operador: "Facturación y Cobro" ──
export const previewCobro = (data) => Axios.post(`${COBRO}/preview`, data);
export const generateCobroNotes = (data) => Axios.post(`${COBRO}/generate`, data);
export const listCobroNotes = (params) => Axios.get(COBRO, { params });
export const getCobroNote = (id) => Axios.get(`${COBRO}/${id}`);
export const voidCobroNote = (id, reason) =>
  Axios.post(`${COBRO}/${id}/void`, { reason });
export const notifyCobroNote = (id) => Axios.post(`${COBRO}/${id}/notify`);
export const regenerateCobroPdf = (id) =>
  Axios.post(`${COBRO}/${id}/regenerate-pdf`);
// Comercios con pedidos por cobrar en el período y modo, con el contrato con el que billing
// los tarifaría: { items: [{ companyId, companyName, packageCount, contractSource:
// 'in_effect'|'latest'|'none', contractId, contractStatus, contractEndDate }] }. Fechas
// 'YYYY-MM-DD'. Un solo segmento bajo /billing/cobro: el BFF lo cubre con su AdminOnly.
export const getBillableCompanies = ({ chargeMode, periodStart, periodEnd }) =>
  Axios.get(`${COBRO}/billable-companies`, { params: { chargeMode, periodStart, periodEnd } });
// Marca varias notas como pagadas de una vez (cobro registrado fuera del sistema).
// Nunca falla por una nota individual: devuelve { updated, ok, skipped:[{noteId, reason}] }.
export const markCobroNotesPaid = (noteIds) =>
  Axios.post(`${COBRO}/mark-paid-selection`, { noteIds });

// ── Operador: pagos parciales y saldo a favor ──
// Registra un pago en una nota ({ amount, paidAt, method, reference?, comment? }).
export const registerPayment = (id, data) =>
  Axios.post(`${COBRO}/${id}/payments`, data);
// Anula un pago (no lo borra). `paymentId` puede ser 'legacy'.
export const voidPayment = (id, paymentId, reason) =>
  Axios.post(`${COBRO}/${id}/payments/${paymentId}/void`, { reason });
// Reparte un abono entre varias notas del mismo deudor y moneda.
export const allocatePayment = (data) =>
  Axios.post(`${COBRO}/payments/allocate`, data);
// Saldos a favor del deudor ({ companyId } o { holdingId }, onlyOpen).
export const listCredits = (params) =>
  Axios.get(`${COBRO}/payments/credits`, { params });

// ── Comercio: sección "Pagos" ──
export const listMyCobroNotes = (params) =>
  Axios.get(`${COBRO}/my/notes`, { params });
export const getMyCobroNote = (id) => Axios.get(`${COBRO}/my/notes/${id}`);

// ── Pago (integrations) ──
// Métodos de pago disponibles para una nota (pasarelas activas del operador).
export const getPaymentMethods = (noteId) =>
  Axios.get(`${PAY}/methods`, { params: { noteId } });
export const createCharge = (data) => Axios.post(`${PAY}/charge`, data);
// Verificación on-demand: reconcilia el pago contra el PSP (no depende del webhook).
export const verifyPayment = (noteId) =>
  Axios.post(`${PAY}/verify`, { noteId });

// ── Configuración del proveedor de pago del operador ──
export const getPaymentConfig = () => Axios.get(`${PAY}/config`);
export const savePaymentConfig = (data) => Axios.post(`${PAY}/config`, data);

// ── Datos bancarios del operador (transferencia manual) ──
export const getBankSettings = () => Axios.get(`${PAY}/bank-settings`);
export const saveBankSettings = (data) => Axios.post(`${PAY}/bank-settings`, data);

// ── Transferencia manual ──
// Sube el comprobante por el proxy de archivos (ms-s3). Devuelve { files:[{location,key}] }.
export const uploadPaymentProof = (file, noteId) => {
  const fd = new FormData();
  fd.append("files", file);
  fd.append("dir", `payment-proofs/${noteId}`);
  return Axios.post("/files/s/upload/img", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
// Comercio: informa la transferencia (solo metadatos del comprobante).
export const createTransfer = (data) => Axios.post(`${PAY}/transfer`, data);
// Comercio: informa un pago en efectivo (sin comprobante).
export const createCash = (data) => Axios.post(`${PAY}/cash`, data);
// Comprobante como blob (descarga autenticada: la URL pública no se expone).
export const getTransferProof = (noteId) =>
  Axios.get(`${PAY}/transfer/${noteId}/proof`, { responseType: "blob" });
// Operador: confirma / rechaza el pago en revisión. `amount` es el monto real
// recibido (opcional: si falta, integrations usa el monto vigente de la nota).
export const confirmTransfer = (noteId, amount) =>
  Axios.post(`${PAY}/transfer/${noteId}/confirm`, amount == null ? undefined : { amount });
export const rejectTransfer = (noteId, reason) =>
  Axios.post(`${PAY}/transfer/${noteId}/reject`, { reason });
